import config from './config.js';
import { mainLog } from './logger.js'
const DEFAULT_CMP_FUNCTION = '__cmp';

const hasConsent = () => {
  const cfg = config.getConfig();
  if (!cfg.consent?.enabled) {
    return true;
  }

  const cmpFunction = cfg.consent.cmpFunction || DEFAULT_CMP_FUNCTION;

  try {
    if (typeof window[cmpFunction] === 'function') {
      const result = window[cmpFunction]('consentStatus');
      return result?.consentExists === true;
    } else {
      return false;
    }
  } catch (e) {
    mainLog('Consent check error', e);
    return false;
  }
};

const consent = {
  hasConsent,
};

export default consent;